import { useDispatch, useSelector } from 'react-redux'
import { FoundationsPageType } from '../../Types/FoundationsTypes'
import { Header } from './Header'
import { getAppRedirectURL, getCurrentUserData, RootState, setAppRedirectURL } from '../../Redux/store'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from "react-toastify";
import { useEffect } from 'react'
import { Footer } from './Footer'
import { FoundationsConstants } from '../../FoundationsConstants'
import { TitleProvider } from '../../Hooks/useTitleContext';

// Footer and Header components will be used when we do not use a Unicorn frame
// import { Footer } from "./Footer"
// import { Header } from "./Header"

export function PageFrame(props: FoundationsPageType) {
    //TODO: FP-10887 - Not the best place to do this, but at the moment, this is the first place that hits after router.
    // Lets talk to Steven and see if he wants to put in a component for redirects. We can, but may be its overkill?
    const appRedirectURL = useSelector(
        (state: RootState) => getAppRedirectURL(state)
    )
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (appRedirectURL) {
            dispatch(setAppRedirectURL(null));
            navigate(appRedirectURL, { replace: true });
        }
    }, []);
    const currentUserData = useSelector(
        (state: RootState) => getCurrentUserData(state)
    )

    return (
        <>
            <TitleProvider>
                <div className={`unicorn-scope ${props.hasHeader && currentUserData?.DisplayMode == FoundationsConstants.DisplayMode.Night ? "night-mode" : ""}` } style={{ minHeight: "100vh" }}>
                    {props.hasHeader && < Header />}

                    <div className="row mx-auto mt-4" id="main_section" style={{ position: "relative" }}>
                        <div className="col-12 col-xl-12 col-lg-12 m-auto">
                            <div id="content">
                                <div id="workspace_region" className="w-100">
                                    {props.children}
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                    {props.hasFooter && <Footer alignment={props.footerAlignment || 'start'} />}
                </div>
            </TitleProvider>
        </>
    )
}
